import { ROUTES } from 'shared/constants';
import { GetRoutesFn, AdminRoute } from 'shared/routes/';

import { MemberDetailsRouter } from './pages/MemberDetailsRouter';
import { MembersPage } from './pages/MembersPage';

export const getAdminMembersRoutes: GetRoutesFn = () => [
  {
    routeComponent: AdminRoute,
    path: ROUTES.admin.members.index,
    exact: true,
    component: MembersPage,
  },
  {
    routeComponent: AdminRoute,
    path: ROUTES.admin.members.member,
    component: MemberDetailsRouter,
  },
];
